import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  &:hover {\n    color: ",
        ";\n\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n\n  &:focus {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button as ButtonBase, Text } from "@miro-site/core";
import React from "react";
import styled from "styled-components";
import { Categories, Close } from "../../icons/Icons";
var Button = styled(ButtonBase).withConfig({
    componentId: "sc-6e2723c3-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryBlue;
}, Text, function(param) {
    var theme = param.theme;
    return theme.colors.primaryBlue;
}, function(param) {
    var theme = param.theme;
    return theme.normalizeStyles(_object_spread({}, theme.focus.outlines.default));
});
var CategoryButton = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var children = _param.children, isOpened = _param.isOpened, isSearchActive = _param.isSearchActive, props = _object_without_properties(_param, [
        "children",
        "isOpened",
        "isSearchActive"
    ]);
    return /*#__PURE__*/ _jsxs(Button, _object_spread_props(_object_spread({
        "data-track-id": "category-menu-button",
        $buttonType: "secondary",
        $size: "small",
        ref: ref,
        $styles: {
            position: isSearchActive ? "absolute" : "relative"
        }
    }, props), {
        children: [
            isOpened ? /*#__PURE__*/ _jsx(Close, {
                width: 20,
                height: 20
            }) : /*#__PURE__*/ _jsx(Categories, {
                width: 20,
                height: 20
            }),
            /*#__PURE__*/ _jsx(Text, {
                as: "span",
                $ml: 7,
                $variant: "p2",
                children: children
            })
        ]
    }));
});
CategoryButton.displayName = "CategoryButton";
export default CategoryButton;
